import { useMemo } from "react";
import { PERMISSIONS } from "../utils/permissionCodes";
import { useAuth, usePermissions } from "./usePermissions";

export function useListsPermissions() {
  const { isAdmin } = useAuth();
  const { hasPermission, hasAnyPermission } = usePermissions();

  const canViewListsNav = isAdmin;
  const canViewBanks = hasPermission(PERMISSIONS.BANKS_VIEW);
  const canViewUnits = hasPermission(PERMISSIONS.UNITS_VIEW);
  const canViewPropertyTypes = hasPermission(PERMISSIONS.PROPERTY_TYPES_VIEW);
  const canViewContactCategories = hasPermission(
    PERMISSIONS.CONTACT_CATEGORIES_VIEW,
  );
  const canViewUsers = hasPermission(PERMISSIONS.USERS_VIEW);
  const canViewPhaseLists = hasAnyPermission([
    PERMISSIONS.PHASES_VIEW,
    PERMISSIONS.SUBPHASES_VIEW,
    PERMISSIONS.PHASES_BY_PROPERTY_TYPE_VIEW,
  ]);

  return useMemo(
    () => ({
      canViewListsNav,
      canViewBanks,
      canViewUnits,
      canViewPropertyTypes,
      canViewContactCategories,
      canViewUsers,
      canViewPhaseLists,
    }),
    [
      canViewBanks,
      canViewContactCategories,
      canViewListsNav,
      canViewPhaseLists,
      canViewPropertyTypes,
      canViewUnits,
      canViewUsers,
    ],
  );
}
